"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.breakpointSize = exports.delayTime = exports.dashboardMode = exports.compactTypes = void 0;

/**
 * @desc
 * Compacting type.
 *
 * @enum
 *
 * @type {{HORIZONTAL: string, VERTICAL: string, OFF: string}}
 */
var compactTypes = {
  HORIZONTAL: 'horizontal',
  VERTICAL: 'vertical',
  OFF: 'off'
};
/**
 * @desc
 * Dashboard mode.
 *
 * @enum
 *
 * @type {{EDIT: string, VIEW: string}}
 */

exports.compactTypes = compactTypes;
var dashboardMode = {
  EDIT: 'edit',
  VIEW: 'view'
};
/**
 * @desc
 * Delay times.
 *
 * @enum
 *
 * @type {{RESIZE: number}}
 */

exports.dashboardMode = dashboardMode;
var delayTime = {
  ONRESIZE: 200
};
/**
 * @desc
 * Breakpoint sizes.
 *
 * @enum
 *
 * @type {{LG: number, MD: number, SM: number, XS: number, XXS: number}}
 */

exports.delayTime = delayTime;
var breakpointSize = {
  LG: 'lg',
  MD: 'md',
  SM: 'sm',
  XS: 'xs',
  XXS: 'xxs'
};
exports.breakpointSize = breakpointSize;
//# sourceMappingURL=constants.js.map